"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const destinations = [{
  id: "textures-calcaires",
  title: "Textures Calcaires",
  subtitle: "L'empreinte du temps",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627813/img/limestone_texture.png",
  colSpan: "md:col-span-8",
  link: "#"
}, {
  id: "faune-sauvage",
  title: "Faune Sauvage",
  subtitle: "Rencontres silencieuses",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627813/img/wild_deer_anticosti.png",
  colSpan: "md:col-span-4",
  link: "#"
}, {
  id: "horizon-infini",
  title: "Horizon Infini",
  subtitle: "Le souffle du large",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627813/img/anticosti_horizon.png",
  colSpan: "md:col-span-5",
  link: "#"
}, {
  id: "chutes-vaureal",
  title: "Chutes Vauréal",
  subtitle: "La force du silence",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627813/img/vaureal_waterfall.png",
  colSpan: "md:col-span-7",
  link: "#"
}];
export default function RutasInexploradasDestinosEstrella() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}